import { PaginatedFileUploadResponse } from '@aslanpay/portal-common-lib';
import { useQuery } from '@tanstack/react-query';

import { SAVINGS_PRESET_IMAGE_UPLOAD_TYPE } from 'app/constants/fileUploads';

import FileProcessingApiHandler from 'app/services/fileProcessingApiHandler';

export const SAVINGS_PRESET_IMAGES_QUERY_KEY = 'savingsPresetImages';

// Presets fetched in one page. The catalogue is small and curated by ops/admins, and the endpoint
// caps size at 100, so a single max-size page comfortably covers it.
const SAVINGS_PRESET_PAGE_SIZE = 100;

// The file-processing list endpoint requires a companyId, but savings presets are a global catalogue
// with no owning company — and Aslan admins (the only users of this page) have no company_id of their
// own. A nil-UUID sentinel is sent purely to satisfy the required parameter; the backend matches
// "this company OR global (null company)", so for the savings-preset type — which is always
// null-company — the value is irrelevant and only the global catalogue is returned.
const GLOBAL_CATALOGUE_COMPANY_ID = '00000000-0000-0000-0000-000000000000';

/**
 * Fetches the global savings preset cover-image catalogue (savings-preset type, no owning company).
 */
const useFetchSavingsPresetImages = () =>
  useQuery({
    queryKey: [SAVINGS_PRESET_IMAGES_QUERY_KEY],
    queryFn: () =>
      FileProcessingApiHandler.getAllFiles(
        GLOBAL_CATALOGUE_COMPANY_ID,
        SAVINGS_PRESET_IMAGE_UPLOAD_TYPE,
        0,
        SAVINGS_PRESET_PAGE_SIZE
      ) as Promise<PaginatedFileUploadResponse>,
  });

export default useFetchSavingsPresetImages;
